var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonCloseOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:close-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 2C8.2 2 2 8.2 2 16C2 23.8 8.2 30 16 30C23.8 30 30 23.8 30 16C30 8.2 23.8 2 16 2ZM16 28C9.4 28 4 22.6 4 16C4 9.4 9.4 4 16 4C22.6 4 28 9.4 28 16C28 22.6 22.6 28 16 28Z",
    fill: "url(#paint0_linear_490_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.4 23L16 17.6L10.6 23L9 21.4L14.4 16L9 10.6L10.6 9L16 14.4L21.4 9L23 10.6L17.6 16L23 21.4L21.4 23Z",
    fill: "url(#paint1_linear_490_1398)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_1398",
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_490_1398",
    x1: 16,
    y1: 9,
    x2: 16,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonCloseOutline);
export default __webpack_public_path__ + "static/media/carbon_close-outline.89b26c6d197b3635c14a58122407ab82.svg";
export { ForwardRef as ReactComponent };